import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { EmailSubscription } from '../types';
import { isSearchedItem } from '../utils';
import { fetchSubscriptionList } from '@src/api/emailSubscriptions';

export const useFetchEmailSubscriptionList = (enabled = true) => {
  const [searchText, onSearch] = useState('');

  const { data, isError, isLoading, refetch } = useQuery(
    ['email-subscriptions-list'],
    (): Promise<{ data: EmailSubscription[] }> =>
      fetchSubscriptionList().then((response) => response.data),
    {
      refetchOnWindowFocus: false,
      enabled,
      staleTime: 5 * 60 * 1000,
    },
  );

  const filteredResults = (data?.data || []).filter(
    (item) => item.email && isSearchedItem(item.email, searchText),
  );

  return { data: filteredResults, isError, isLoading, refetch, searchText, onSearch };
};
